<template>
    <div id="res" width="50%">
      <h3>Education</h3>
      <p class="subhead">Bachelors of Computer Engineering</p>
      <p class="sub">University of Victoria Class of 2019<p>
      <h3>Work</h3>
      <p class="subhead">Data infrastructure Engineer, Shopify</p>
      <p class="sub">Since Sept. 2019.<p>
      <p>Moving central data systems onto <b>kubernetes</b>.</p>
      <p>Deploying compute resources in <b>Google Cloud</b> with <b>Terraform.</b></p>
      <p class="subhead">Data infrastructure Intern, Shopify</p>
      <p class="sub">September - December 2018<p>
      <p>Did some stuff.</p>
      <p class="subhead">Research Intern, Humboldt University Berlin</p>
      <p class="sub">September - December 2018<p>
      <p>Developing and evaluating novel scheduling algorithms for Heterogeneous distributed systems.<p>
      <p>Contributed to <a href="https://sc18.supercomputing.org/proceedings/workshops/workshop_files/ws_works104s2-file1.pdf">this</a> publication.</p>
      <p></p>
      <br><br>
    </div>
</template>

<style scoped>



#res p, h3 {
  margin-left: 5%;
  margin-right: 5%;
  vertical-align: middle
}

#res {
  max-width: 550px;
  margin: 0 auto;
}

#res p {
  text-align: left;
  margin-top: 0%;
  margin-bottom: 0%;
}

#res h3 {
  margin-top: 20px;
  margin-bottom: 0%;
}

#res .subhead {
  margin-top: 30px;
  font-weight: bold;

}

#res .sub {
  color: #888888;
  margin-top: 0%;
  margin-bottom: 5%
}

</style>

<script>
export default {
  name: 'Resume'
}
</script> 